import { useEnvironment } from '@ori/environment';
import { getHeaders } from '@ori/fetching';
import { useTranslationsWithNamespaces } from '@ori/i18n';
import { useGetTenantApplicationsAdvisorNovAgeSkincareConfiguration } from '@ori/static-api-client-react';

import { APP_NAME } from '../constants';

export const useGetNovageSkincareConfiguration = (enabled: boolean) => {
  const { tenant } = useEnvironment();
  const { language } = useTranslationsWithNamespaces();
  const { data } = useGetTenantApplicationsAdvisorNovAgeSkincareConfiguration(
    tenant,
    {
      lang: language,
    },
    {
      request: {
        headers: getHeaders({ language, sourceAppName: APP_NAME, tenant }),
      },
      swr: {
        enabled,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        revalidateIfStale: false,
      },
    },
  );

  return data;
};
